<app-container>
  <div class="filter-modal">
    <div class="filter-modal-header">
      <h6 class="title">
        {{ page.translation?.data?.filterTitle || "Фильтри" }}
      </h6>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <div class="filter-grid">
        @for (filter of filterOptions; track filter) {
          <div class="filter-item">
            <label class="filter-label">{{ filter.label }}</label>
            <mat-form-field appearance="outline">
              <mat-select
                [placeholder]="
                  page.translation?.data?.filterPlaceholder || 'Оберіть'
                "
                [value]="getSelectedValue(filter.id)"
                (selectionChange)="onFilterChange(filter.id, $event)"
                disableRipple
              >
                @for (option of filter.options; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button class="_btn outline medium" (click)="clear()">
        {{ page.translation?.data?.filterClearButtonTitle || "Очистити" }}
      </button>
      <button class="_btn black medium" (click)="apply()">
        {{ page.translation?.data?.filterApplyButtonTitle || "Застосувати" }}
      </button>
    </mat-dialog-actions>
  </div>
</app-container>
